import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent } from '../../schema'
import { CreateNoteParams, CreateNoteRequestBody } from './create'

export function resourceObject(
  attributes: CreateNoteRequestBody & CreateNoteParams & { userId: string }
): OpalApiComponent<'V3', 'note'> {
  return {
    id: uuidv4(),
    type: 'note',
    attributes: {
      comment: attributes.note.comment,
      legacy_id: '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    },
    // The moment is a placeholder, like `legacy_id`: the refetch after the
    // write replaces this optimistic note, and the client does not know the
    // moment's uuid.
    relationships: {
      content: { data: null },
      moment: { data: null },
      user: { data: { id: attributes.userId, type: 'user' } },
    },
  }
}
